module.exports = {
  // Color
  brandPrimary: '#E11E26',
  brandInfo: '#62B1F6',
  brandSuccess: '#5cb85c',
  brandDanger: '#d9534f',
  brandWarning: '#f0ad4e',
  brandDark: '#000',
  brandLight: '#f4f4f4',
  ckBrandBackground: '#fff',

  // Button
  btnDisabledBg: '#b5b5b5',

  // Font
  fontSizeBase: '18px',
  fontSizeSm: '16px',
  fontFamily: 'Gamestation-Text',

  // Text
  textColor: '#32474e',
};
